module.exports = __webpack_public_path__ + "img/newLogo.4db0dd5a.png";